'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingIndicator = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(LoadingIndicator, _React$Component);

  function LoadingIndicator() {
    (0, _classCallCheck3.default)(this, LoadingIndicator);
    return (0, _possibleConstructorReturn3.default)(this, (LoadingIndicator.__proto__ || (0, _getPrototypeOf2.default)(LoadingIndicator)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoadingIndicator, [{
    key: 'render',
    value: function render() {
      var styles = require('./LoadingIndicator.scss');
      var className = this.props.className;


      return _react2.default.createElement(
        'span',
        { className: className },
        _react2.default.createElement('span', { className: styles.LoadingIndicator })
      );
    }
  }]);
  return LoadingIndicator;
}(_react2.default.Component), _class.propTypes = {
  className: _react2.default.PropTypes.string
}, _class.defaultProps = {
  className: ''
}, _temp);
exports.default = LoadingIndicator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingIndicator/LoadingIndicator.jsx
// module id = 2628
// module chunks = 0